<template lang="pug">
  .socket-state(:class="state")
    .round
    .text(v-if="show_text") {{human_text}}
</template>

<script>
export default {
name: "SocketState",
props: {
  state: {
    type: String,
    default: 'disconnected',
  },
  show_text: {
    type: Boolean,
    default: true,
  }
},
  computed: {
  human_text(){
    if (this.state === 'connected') return 'online';
    if (this.state === 'disconnected') return 'offline';
    return this.state;
  }
  }
}
</script>

<style scoped>
  .socket-state{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .socket-state .text{
    color: #bbbdbe;
    font-size: 12px;
    padding-left: 5px;
  }
  .socket-state .round{
    height: 10px;
    width: 10px;
    border-radius: 5px;
    background-color: #6c757d;
  }
  .socket-state.connected .round{
    background-color: #b3dd2d;
  }

  .socket-state.disconnected .round{
    background-color: #df3920;
  }

</style>